/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          : DeleteProduct.tsx
*
* Project Title : Checkout
*
* Description   : Initial version
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : Deepthi B (E844276)
*
* @Date         : Sep 23, 2019
*
* @Version      : Version 1.0
*
* By            : Deepthi B (E844276)
* On            : Sep 23, 2019
* Description   : Added the code to delete aspire product - ASDS-413
*
* By            : H224423
* On            : Oct 10, 2019
* Description   : ASDS-1478 - Grid level resposnive changes and UI issue fixes.
*
* By            : H224423
* On            : Oct 21, 2019
* Description   : ASDS-1548 changes.
*
* By            : E844276
* On            : Oct 31, 2019
* Description   : ASDS-408 changes.
 *
 * By            : H224423
 * On            : Dec 17 2019
 * Description   : UT Automation
 *
 * By            : H422336
 * On            : Oct 13, 2020
 * Description   : ASDS - 3262, ASDS-3263 UI Enhancements for Phase - II
 *
 * By            : H422337
 * On            : Oct 13, 2020
 * Description   : ASDS-3562 UI Enhancements for phase-2
 *
 * By            : H422336
 * On            : Nov 7 2020
 * Description   : ASDS-3832 UI Enhancements for Phase-II
 *
******************************************************************************/
import * as React from 'react';
import { Modal, Grid, Card, Table, Button } from '@scuf/common';
import '@scuf/common/honeywell/theme.css';
import './../ReviewOrder/reviewOrder.css';
import CheckoutConstants from '../constants/checkout-constants';

interface IDeleteProduct {
    open: boolean;
    onClose: Function;
    product: any;
    onClick: Function;
}

function DeleteProduct(props: IDeleteProduct) {
    const productName = props.product.prodName ? 'prodName' : 'productName';

    return(
        <Modal className="delete-pop-up" closeIcon={true} open={props.open} onClose={() => props.onClose()} closeOnDimmerClick={false}>
            <Modal.Header>
                <span className="dap-modal-header">Do you want to delete the following product?</span>
            </Modal.Header>
            <Modal.Content>
                <React.Fragment>
                    <Card>
                        <Card.Content>
                            <Grid.Row>
                                <Grid.Column width={12} className="delete_product_list">
                                    <Table className="dap-modal-table unstackable">
                                        <Table.Header>
                                            <Table.HeaderCell className="product-width product_name" content="PRODUCT" textAlign="left" />
                                            <Table.HeaderCell content="QUANTITY" textAlign="center" />
                                            <Table.HeaderCell content=" EXTENDED PRICE" textAlign="center" />
                                        </Table.Header>
                                        <Table.Body>
                                            <Table.Row>
                                                <Table.Cell textAlign="left">
                                                <div className="display-flex">
                                                <div className="dav-product-icon">
                                                {props.product[productName].toLowerCase().includes(CheckoutConstants.APU_PRODUCT_NAME)
                                                    &&<i className={CheckoutConstants.APU_PRODUCT_CLASSNAME + ' cart-product-icon'}></i>}

                                                    {props.product[productName].toLowerCase().includes(CheckoutConstants.ASPIRE_PRODUCT_NAME)
                                                    &&<i className={CheckoutConstants.ASPIRE_PRODUCT_CLASSNAME + ' cart-product-icon'}></i>}

                                                    {props.product[productName].toLowerCase().includes(CheckoutConstants.DLMUW_PRODUCT_NAME)
                                                    &&<i className={CheckoutConstants.DLMUW_PRODUCT_CLASSNAME + ' cart-product-icon'}></i>}

                                                    {props.product[productName].toLowerCase().includes(CheckoutConstants.ANALYZER_SERVICE_CENTERS_PRODUCT_NAME)
                                                    &&<i className={CheckoutConstants.ANALYZER_PRODUCT_CLASSNAME + ' cart-product-icon'}></i>}

                                                    {props.product[productName].toLowerCase().includes(CheckoutConstants.FAULT_ANALYZER_SERVICES_PRODUCT_NAME)
                                                    &&<i className={CheckoutConstants.FAULT_PRODUCT_CLASSNAME + ' cart-product-icon'}></i>}

                                                    {props.product[productName].toLowerCase().includes(CheckoutConstants.REMOTE_TERMINAL_SERVICES_PRODUCT_NAME)
                                                    &&<i className={CheckoutConstants.REMOTE_TERMINAL_PRODUCT_CLASSNAME + ' cart-product-icon'}></i>}
                                                </div>
                                                <span>{props.product[productName]}</span>
                                                </div>
                                                {/* TODO: Icons need to be updated. Test the below commented code. */}
                                                {/*props.product.iconApplicable && <Icon name={props.product.attributeName || ''} size="large" />*/}
                                                {/*props.product.classNameApplicable && <i className={props.product.attributeName}></i>
                                            {props.iconApplicable && <Icon name={props.attributeName || ''} size="large" />}
                                                    {props.classNameApplicable && <i className={props.attributeName} />}*/}
                                                </Table.Cell>
                                                <Table.Cell textAlign="center">{props.product.cartList ? props.product.cartList.length : props.product.quantity}</Table.Cell>
                                                <Table.Cell textAlign="center">${props.product.amount ? props.product.amount : props.product.totalPrice.toFixed(2)}</Table.Cell>
                                            </Table.Row>
                                        </Table.Body>
                                    </Table>
                                </Grid.Column>
                            </Grid.Row>
                        </Card.Content>
                    </Card>
                </React.Fragment>
            </Modal.Content>
            <Modal.Footer>
                <div className="display-flex">
                    <Button type="secondary" className="co-secondary-button" content="BACK" onClick={() => {props.onClose(); }}/>
                    <Button type="primary" className="co-primary-button" content="DELETE" onClick={() => {props.onClick();}} />
                </div>
            </Modal.Footer>
        </Modal>
    );
}

export default DeleteProduct;